import { render } from "./UserView.vue?vue&type=template&id=5bdcda94&scoped=true&ts=true"
import script from "./UserView.vue?vue&type=script&lang=ts"
export * from "./UserView.vue?vue&type=script&lang=ts"

import "./UserView.vue?vue&type=style&index=0&id=5bdcda94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdcda94"]])

export default __exports__